import { Injectable } from '@angular/core';
import { keys } from '@y42/util/object-utils';
import { SsoStorage, SsoStorageKey } from '../../models/sso-storage.model';
import { SsoBrowserStorageService } from './sso-browser-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SsoStorageService {
  constructor(private readonly ssoBrowserStorageStorageService: SsoBrowserStorageService) {}

  private readonly keys: SsoStorageKey[] = ['sso_session_id', 'acl_version', 'impersonation_id'];

  persistSsoAuth(): void {
    const ssoAuth = this.getSsoAuthFromQueryParams();

    keys(ssoAuth).forEach((key) => {
      const value = ssoAuth[key];
      if (value) {
        this.ssoBrowserStorageStorageService.setItem(key, value);
      }
    });
  }

  clearSsoAuth(): void {
    this.ssoBrowserStorageStorageService.clear();
  }

  getSsoAuthFromStorage(): SsoStorage {
    return this.ssoBrowserStorageStorageService.getSsoAuth();
  }

  getSsoAuthFromQueryParams(): SsoStorage {
    const searchParams = new URL(document.location.toString()).searchParams;
    const source: Record<string, string> = {};

    searchParams.forEach((value, key) => {
      source[key] = value;
    });

    return this.filterSsoAuthFromSource(source);
  }

  private filterSsoAuthFromSource(source: Record<string, string>): SsoStorage {
    return this.keys.reduce((acc, item) => {
      const data = source[item];
      if (data) {
        acc[item] = data;
      }
      return acc;
    }, {} as SsoStorage);
  }
}
